import api from '../token';

export const CancelarPedido = async (produto) => {
  try {
    const response = await api.post('/CancelarPedidosMesaAll', produto);
    return response.data;
  } catch (error) {
    console.error('Erro ao adicionar produto:', error);
    return { success: false, message: error.message };
  }
};



